import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const MODULE_PARAM = 'module';
export const TOPIC_PARAM = 'topic';

export function useSchoolLearnNav() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeModuleId = searchParams.get(MODULE_PARAM);
  const activeTopicId = searchParams.get(TOPIC_PARAM);

  const scrollTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const openModule = useCallback(
    (moduleId: string) => {
      setSearchParams({ [MODULE_PARAM]: moduleId }, { replace: false });
      scrollTop();
    },
    [setSearchParams, scrollTop],
  );

  const openTopic = useCallback(
    (topicId: string) => {
      setSearchParams({ [TOPIC_PARAM]: topicId }, { replace: false });
      scrollTop();
    },
    [setSearchParams, scrollTop],
  );

  const goToHub = useCallback(() => {
    setSearchParams({}, { replace: false });
    scrollTop();
  }, [setSearchParams, scrollTop]);

  const goToModule = useCallback(
    (moduleId: string) => {
      setSearchParams({ [MODULE_PARAM]: moduleId }, { replace: false });
      scrollTop();
    },
    [setSearchParams, scrollTop],
  );

  return {
    activeModuleId,
    activeTopicId,
    openModule,
    openTopic,
    goToHub,
    goToModule,
  };
}
